<template>
   <v-row class="overflow-auto py-5" id="container">
        <v-col
            cols="4"
            class="py-2"
            v-for="item in items"
            :key="item.name"
        >
            <v-card
                shaped
                :class="`rounded-card mx-auto mt-5 item py-5 px-5 ${ choice === item.id && 'selected' }`"
                max-width="344"
                max-height="300px"
                @click="choice = item.id"
            >
                <div class="text-center">
                    <img :src="item.img" />
                </div>

                <div class="text-center mt-5" v-html="item.desc2">
                </div>
            </v-card>
        </v-col>
   </v-row>
</template>

<script>
export default {
    props: {
        isCar: Boolean,
    },
    data: () => ({
        choice: 0,
        items: [
            {
                id: 1,
                name: 'Sterling Bank',
                img: 'https://upload.wikimedia.org/wikipedia/commons/1/19/Sterling_bank_logo_wk.png',
                desc: '$300 per month for 60 months <br /> with 15% down payment',
                desc2: 'Annual Interest:  1% <br /> Duration: 12 months',
            },
            {
                id: 2,
                name: 'Rigo microfinance',
                img: 'https://www.rigomfb.com/static/assets/logo.png',
                desc: '$350 per month for 60 months <br /> with 12.5% down payment',
                desc2: 'Annual Interest:  1.5% <br /> Duration: 18 months',
            },
            {
                id: 3,
                name: 'First Bank',
                img: 'https://www.firstbanknigeria.com/wp-content/uploads/2019/02/cropped-logo_blue-2.png',
                desc: '$400 per month for 60 months <br /> with 10% down payment',
                desc2: 'Annual Interest:  2% <br /> Duration: 24 months',
            },
        ],
    }),
}
</script>

<style scoped>
.item img {
    height: 90px;
}

.item:hover {
    border: 1px solid #3F51B5;
    transition: border 0.5s ease-in;
    cursor: pointer;
}

.selected {
    border: 2px solid #3F51B5;
}
</style>